<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        サイトアップロードセンター
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">サイト</a>
          </li>
      </ul>
    </div>
    <b-card>
      <template slot="header"><i class='fa fa-align-justify'></i>サイトアップロードセンター</template>
        <b-row class="step_box">
          <b-col sm="12">
            STEP 1. サンプルファイルのダウンロード :
            <b-button class="mt-0" variant="link" @click="modal_charge_agree = true">サンプルファイルを取得</b-button>
          </b-col>
        </b-row>
        <hr>
        <b-row class="step_box">
          <b-col sm="12">
            STEP 2. 登録したいサイトをサンプルに追加してアップロード。CSVファイル対応
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="1">
            <strong>
              ファイル
            </strong>
          </b-col>
          <b-col>
            <b-form-file
              ref="file_input"
              v-model="file"
              @input="selected"
              @change="selected"
              :state="Boolean(file && file.name)"
              placeholder="ファイルを選択するか、ここにドロップします..."
              drop-placeholder="Drop file here..."
              :allowed="true"
              accept="text/csv"
            ></b-form-file>
          </b-col>
          <b-col sm="1">
            <b-btn :disabled="!file || (file && !file.name) || loading" @click="reset" block variant="outline-danger">クリア</b-btn>
          </b-col>
        </b-row>
        <hr>
        <b-row class="step_box">
          <b-col sm="10">
            STEP 3. 登録したいサイト情報を表示し、アップロード
          </b-col>
          <b-col sm="2">
            <b-badge variant="success">完了済 : {{progress.done}}</b-badge>
            <b-badge variant="danger">エラー : {{progress.error}}</b-badge>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col sm="4">
            <span class="text-center" v-b-tooltip.hover title="表示回数をカスタマイズできます">
              表示回数
              <select v-model="so.perPage" @change="refresh" :disabled="loading">
                <option value="15">デフォルト 15</option>
                <option value=10>10</option>
                <option value=50>50</option>
                <option value=100>100</option>
                <option value=500>500</option>
              </select>
            </span>
          </b-col>
          <b-col sm="4">
          </b-col>
          <b-col sm="4">
            <b-input-group size="sm">
              <b-input-group-prepend>
                <b-btn :disabled="so.adv" variant="outline-secondary" @click="!loading ? refresh() : ''"><i class="fa fa-refresh"></i></b-btn>
                <b-btn :disabled="so.adv" variant="outline-secondary" @click="so = Object.assign({}, so, { skt : '', sv : '' }); !loading ? refresh() : ''"><i class="fa fa-remove"></i></b-btn>
                <b-dropdown :disabled="so.adv" :text="so.skt || '検索'" size="sm" variant="outline-secondary">
                  <b-dropdown-item size="sm" @click="so.sk='fqdn'; so.skt='FQDN'">FQDN</b-dropdown-item>
                  <b-dropdown-item size="sm" @click="so.sk='name'; so.skt='name'">名前</b-dropdown-item>
                </b-dropdown>
              </b-input-group-prepend>
              <b-form-input :disabled="loading" v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
              <b-input-group-append>
                <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="1">
            カラムを表示
          </b-col>
          <b-col md="3">
            <!-- 컬럼 관련 메뉴 -->
            <b-form-group label="">
              <b-form-checkbox-group
                v-model="sel"
                :options="options"
                button-variant="info"
                name="option"
                buttons
              ></b-form-checkbox-group>
            </b-form-group>
          </b-col>
          <b-col>
            <!-- 업로드 관련 메뉴 -->
            <center>
              <b-button :disabled="loading" class="mr-2" size="sm" variant="outline-success" @click="toggle('is_alive')"> トグルの状態 </b-button>
              <b-button :disabled="loading" class="mr-2" size="sm" variant="outline-info" @click="toggle('is_start')"> トグルの自動起動 </b-button>
              <b-button :disabled="loading" class="mr-2" size="sm" variant="primary" @click="upload_multi()"> すべてをアップロード </b-button>
              <b-button :disabled="loading" class="mr-2" size="sm" variant="info" @click="upload_multi(true)"> このページをアップロード </b-button>
              <b-button :disabled="loading" class="mr-2" size="sm" variant="warning" @click="clear_done"> クリア完了 </b-button>
              <b-button :disabled="!loading" class="mr-2" size="sm" variant="outline-warning" @click="stop = true"> 停止 </b-button>
            </center>
            </b-col>
        </b-row>
        <hr v-if="loading">
        <b-row v-if="loading">
          <b-col sm="12">
            <b-progress class="mt-2" :max="sites.length" show-value>
              <b-progress-bar :value="progress.done" variant="success"></b-progress-bar>
              <b-progress-bar :value="progress.error" variant="danger"></b-progress-bar>
            </b-progress>
          </b-col>
        </b-row>
        <hr>
        <!-- <vcl-facebook v-if="loading"></vcl-facebook> -->
        <b-table hover striped small responsive="sm" ref="_list" show-empty empty-text="not found"
          :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk" class="table-responsive table_add">
          <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
          <template slot="is_alive" slot-scope="row">
            <c-switch color="info" label size="sm" v-model="row.item.is_alive" />
          </template>
          <template slot="is_start" slot-scope="row">
            <c-switch color="info" label size="sm" v-model="row.item.is_start" />
          </template>
          <template slot="name" slot-scope="row">
            <span>{{row.item.name || '-'}}</span>
          </template>
          <template slot="fqdn" slot-scope="row">{{row.item.fqdn || '-'}}</template>
          <template slot="seeds" slot-scope="row">
            {{row.item.seeds.length > 1 ? `${row.item.seeds[0]} .. more ${row.item.seeds.length - 1}` : row.item.seeds[0] || '-'}}
          </template>
          <template slot="schedule" slot-scope="row">
            {{row.item.schedule.length > 1 ? `${row.item.schedule[0]} .. more ${row.item.schedule.length - 1}` : row.item.schedule[0] || '-'}}
          </template>
          <template slot="subs" slot-scope="row">
            {{row.item.subs.length > 1 ? `${row.item.subs[0]} .. more ${row.item.subs.length - 1}` : row.item.subs[0]}}
          </template>
          <template slot="prevents" slot-scope="row">
            {{row.item.prevents.length > 1 ? `${row.item.prevents[0]} .. more ${row.item.prevents.length - 1}` : row.item.prevents[0] || '-'}}
          </template>
          <template slot="policy" slot-scope="row">
            {{row.item.policy && row.item.policy ? row.item.policy : '-'}}
          </template>
          <template slot="func" slot-scope="row">
            <!-- {{startRow - (startRow - row.index)}} -->
             <p>
              <b-tooltip target="disabled-wrapper">{{row.item.msg}}</b-tooltip>
             </p>
             <span  id="disabled-wrapper" class="d-inline-block">
              <b-btn @click="upload_one(row.index, row.item.fqdn)" :disabled="row.item.is_done" size="sm" :variant="row.item.is_error ? 'danger' : 'outline-primary'">
                <span v-if="row.item.is_error == true" style="cursor:pointer">
                  エラー (?)
                </span>
                <span v-else>{{ row.item.is_done ? 'Done' : 'Upload' }}</span>
              </b-btn>
             </span>
          </template>
        </b-table>
        <hr>
        <b-row>
          <b-col md="4">

          </b-col>
          <b-col md="4">
            <b-pagination size="sm" align="center" :limit="10" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
          </b-col>
          <b-col class="md-4">
            <div class="pull-right">
              <b-button class="mr-2 btn-add" size="sm" variant="success" @click="list"> 一覧 </b-button>
            </div>
          </b-col>
        </b-row>
      </b-card>
    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
    <b-modal v-model="modal_charge_agree" title="アップロードファイルのダウンロード" @ok="charge_agree" no-close-on-backdrop header-bg-variant="warning">
      <h5>サンプルファイル作成後、アップロード時に検査が開始されます。</h5>
      <!-- <hr>
      <a target="_blank" :href="redir" class="card-link">
        <span class="text-dark">더 보기</span>
        <i class="fa fa-share"></i>
        {{redir}}
      </a> -->
      <hr>
      <h6> <b>ダウンロードを希望しますか？</b></h6>
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
